import React, { Component } from "react";
import Modal from "react-modal";
import { Redirect } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import "../../common.css";

import LoadingPage from "@components/Loading/Loading";
import config from "@config";
import errorFunctions from "@store/errorFunctions";
import utilityFunctions from "@store/utilityFunctions";
import { postNewStaffFunction } from "./api";
import "./StaffAdd.css";
import SelectOption from "@components/Select/SelectOption";
Modal.setAppElement("body");

const cin7Options = [
  { label: "None", value: "no_access" },
  { label: "Partial", value: "partial" },
  { label: "All", value: "all" },
];
export default class StaffAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      redirect: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: "",
      name: "",
      email: "",
      password1: "",
      password2: "",
      errorPassword: false,
      errorBrand: false,
      typePassword: true,
      storeLocationValue: null, // Changed from storeLocationId
      storeLocationId: "",
      cin7Name: "",
      cin7Access: { label: "None", value: "no_access" }, // Fixed: was { name: "None", value: "no_access" }
    };
  }

  componentDidMount() {
    this.retriveAllBrand();
    this.retriveAllRoles();
  }

  retriveAllBrand = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "brands/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, brands: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  retriveAllRoles = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "roles/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, roles: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  addExistingUser = (userId) => {
    this.setState({ loading: true });
    if (!userId && !this.state.storeLocationId) {
      alert("User is not selected");
      return;
    }
    let payload = {
      employee_id: userId,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post(
        `${config.backendServer}store_location/${this.state.storeLocationId}/add_staff/`,
        payload,
        options
      )
      .then((res) => {
        let tempUsers = [...this.state.data];
        tempUsers.push(res.data);
        this.setState({
          loading: false,
          showAddUser: false,
          data: tempUsers,
          employeeID: "",
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
      });
  };

  handleSubmit = async (event) => {
    this.setState({ loading: true });
    event.preventDefault();
    const selectedBrandIds = Array.from(
      document.getElementsByName("brand-check")
    )
      .filter((ck) => ck.checked)
      .map((checkbox) => checkbox.value);

    let payload = {
      brands: selectedBrandIds,
      name: this.state.name ? this.state.name : this.state.details?.name,
      email: this.state.email ? this.state.email : this.state.details?.email,
      user_role: this.state.currentRole,
      password1: this.state.password1,
      password2: this.state.password2,
      cin7_name: this.state.cin7Name,
      cin7_access: this.state.cin7Access.value,
    };

    if (
      payload.password1 !== payload.password2 &&
      payload.brands.length === 0
    ) {
      this.setState({ loading: false, errorPassword: true, errorBrand: true });
    } else if (payload.password1 !== payload.password2) {
      this.setState({ loading: false, errorPassword: true, errorBrand: false });
    } else if (payload.brands.length === 0) {
      this.setState({ loading: false, errorBrand: true, errorPassword: false });
    } else {
      const result = await postNewStaffFunction(payload);
      if (result.status === 200 || result.status === 201) {
        if (this.state.storeLocationId) this.addExistingUser(result.data.id);
        this.setState({ redirect: true });
      } else {
        alert(result?.response?.data.non_field_errors?.[0]);
        this.setState({ loading: false });
      }
    }
  };

  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/manage-staff"} />;
    } else if (this.state.loading) {
      return <LoadingPage />;
    }

    return (
      <div className={"page"}>
        <div className="card">
          <h4 className={"card-header"}>Add Staff</h4>
          <form onSubmit={this.handleSubmit}>
            <div className="col-6">
              <div className="card-body">
                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Full Name<span>:</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                  />
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label"}>
                    CIN 7 Access<span>:</span>
                  </label>
                  <Select
                    required
                    id="cin7Access"
                    options={cin7Options}
                    value={this.state.cin7Access}
                    placeholder="Select CIN7 access"
                    onChange={(e) => {
                      this.setState({
                        cin7Access: e,
                      });
                    }}
                  />
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label"}>
                    <span>CIN7 Name :</span>
                  </label>
                  <input
                    type="text"
                    id="cin7Name"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.cin7Name}
                  />
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Email <span>:</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                  />
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Brands<span>:</span>
                  </label>
                  <span>
                    {this.state.brands.map((brand) => (
                      <div className="col-6" key={brand.id}>
                        <div className="form-check">
                          <input
                            name="brand-check"
                            className="form-check-input"
                            type="checkbox"
                            id={`brand-${brand.id}`}
                            value={brand.id}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`brand-${brand.id}`}
                          >
                            {brand.name}
                          </label>
                        </div>
                      </div>
                    ))}
                  </span>
                  {this.state.errorBrand ? (
                    <span className="error-text">Pick at least one brand.</span>
                  ) : null}
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Password{" "}
                    <i
                      className={
                        this.state.typePassword
                          ? "password-show fa fa-eye"
                          : "password-show fa fa-eye-slash"
                      }
                      aria-hidden="true"
                      onClick={() =>
                        this.setState({
                          typePassword: !this.state.typePassword,
                        })
                      }
                    ></i>
                    <span>:</span>
                  </label>
                  <input
                    type={this.state.typePassword ? "password" : "text"}
                    id="password1"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                  />
                  {this.state.errorPassword ? (
                    <span className="error-text">Password did not match</span>
                  ) : null}
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Confirm Password <span>:</span>
                  </label>
                  <input
                    type={this.state.typePassword ? "password" : "text"}
                    id="password2"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                  />
                  {this.state.errorPassword ? (
                    <span className="error-text">Password did not match</span>
                  ) : null}
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label required"}>
                    Role<span>:</span>
                  </label>

                  <span className="container">
                    <select
                      className="form-control custom-select"
                      onChange={this.handleRole}
                      required={true}
                    >
                      <option id="currentRole" value={""}>
                        -Select Role-
                      </option>
                      {this.state?.roles
                        ?.filter(
                          (r) =>
                            r.name !== "Commercial Staff" &&
                            r.name !== "EDI Customer"
                        )
                        .map((val, i) => {
                          return (
                            <option key={i} id="currentRole" value={val.name}>
                              {val.name}
                            </option>
                          );
                        })}
                    </select>
                  </span>
                </div>

                <div className={"single-warranty-details-item"}>
                  <label className={"single-warranty-details-label"}>
                    Store Location<span>:</span>
                  </label>
                  <SelectOption
                    apiEndpoint={
                      config.backendServer + "store_location/dropdown/"
                    }
                    placeholder="Select Location"
                    value={this.state.storeLocationValue}
                    onChange={(e) => {
                      this.setState({
                        storeLocationValue: e,
                        storeLocationId: e?.value || "",
                      });
                    }}
                    // additionalParams={{
                    //   brand_id: utilityFunctions.getCookie("brandId") || "",
                    // }}
                    formatLabel={(item) => item.combine_name}
                  />
                </div>
              </div>
            </div>

            <div className="card-footer">
              <div className="row">
                <div className="col-2">
                  <button className={"btn btn-outline-primary"}>Create</button>
                </div>
                <div className="col-2">
                  <a
                    className={"btn btn-outline-secondary"}
                    href={"/manage-staff"}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
